import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { IntlService } from '@progress/kendo-angular-intl';
import { State } from '@progress/kendo-data-query';
import { CreateEditPaymentComponent } from '@app/core/windows';
import { ServiceContextmenuComponent } from '@app/core/components/contextmenus';
import { FormGroup, FormControl, Validators } from '@angular/forms';


@Component({
  selector: 'accounts-crud',
  templateUrl: './accounts-crud.component.html',
  styles: [
    `.k-autocomplete {
      width: 30%!important;
    }`
  ],
  providers: [ DatasourceService ]
})
export class AccountsCrudComponent extends BaseCrudComponent implements OnInit {

  //Window
  @ViewChild(CreateEditPaymentComponent, {static: false}) window !: CreateEditPaymentComponent;

  //Menu
  @ViewChild(ServiceContextmenuComponent, {static: false}) menu_ser !: ServiceContextmenuComponent;

  protected menu: string = 'Crédito';

  protected menuIcon: string = 'dollar';
  
  protected label: string = 'Estado de cuenta';

  protected name: string = 'Estado de cuenta';

  protected table: string = 'credits';

  protected form: FormGroup = null;  

  protected customer: string = '';
  
  protected customerData: any = null;

  protected data: Array<any> = [];

  protected sumPaid: number = 0;

  protected firstRead: boolean = false;
  
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService, protected intl: IntlService) {
    
    super(authService, service, alertService);
    // console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  }  

  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.take = 0;
    s.sort = [      
      {field: 'credit_days_left', dir: 'desc'}
    ];
    s.filter = {
      logic: "and",
      filters: [
        {field: 'customer_name', operator: 'eq', value: this.customer},
        {field: 'status_payment', operator: 'neq', value: 'PAGADO'}
      ]
    };

    return s;

  }

  public onCustomExcelExport(e: any, allData: Array<any>): void {

    // console.log('onCustomExcelExport');

    const rows = e.workbook.sheets[0].rows;

    let index = 0;
    rows.forEach((row) => {
      if (row.type === 'data') {+
        index++;
        row.cells.forEach((cell, i) => {
          if(typeof cell._column != 'undefined'){
            switch(cell._column){
              case 'Estatus': {
                cell.background = '#' + allData[index-1].status_credit_color;
                cell.color = '#ffffff';
              }; break;
              case 'Costo': {
                cell.format = "$#,##0.00";
              }; break;
            }
          }
        });
      }
    });

  }

  public onCellClick(e: any): void {
      
    // console.log(e);
    // if (e.type === 'contextmenu') {
    //   const originalEvent = e.originalEvent;
    //   originalEvent.preventDefault();
    //   // this.menu_proy.label = 'Folio consecutivo: ' + e.dataItem.folio_consecutivo;
    //   this.menu_ser.contextItem = e.dataItem;
    //   this.menu_ser.menu.show({ left: originalEvent.pageX, top: originalEvent.pageY });
    // }

  }

  // public selectMenu({ menu, contextItem }): void {
    
  //   // console.log("selectMenu", menu, contextItem);

  //   if (menu.url === 'editar') {

  //     this.window.label = this.label;
  //     this.window.table = this.table;
  //     this.window.edit(contextItem);

  //   } else if (menu.url === 'eliminar') {
        
  //     this.removeHandler({dataItem: contextItem});

  //   }

  // }

  ngOnInit() { 
    
    super.ngOnInit();  
  
  }

  get f() { 
    
    return this.form.controls; 
  
  }

  protected customerSelected(event: any){

    this.firstRead = true;

    console.log(event.value, event.items);

    this.customer = event.value;
    
    this.updateCustomer(this.customer);

  }

  protected updateCustomer(customer: string) {

    // console.log('ACTUALIZANDO DATOS');
    let that = this;
    this.state= this.getInitialState()
    this.service.pagination(this.table, this.state, function(res, table, state){
      // console.log(res, table, state);
      res.data.forEach((cell, i) => {
        cell._paid = null;
        cell._credit_pending = cell.credit_pending;
      });
      that.data = res.data;
      that.sumPaid = 0;
    });

    this.service.getByColumn('customers_credits', 'name', customer)
      .subscribe(
        (result: any) => {
          // console.log(result);
          this.customerData = result.data[0];
        },
        (error: any) => {
            // console.log(error)
        });
  }

  protected onChangePago(event: any, dataItem: any) {

    // console.log(event, dataItem);

    var paid = event;
    // dataItem.cost = dataItem.cost - event.target.value;
    // dataItem.credit_paid = (dataItem.credit_paid == null) ? paid: dataItem.credit_paid - paid;
    dataItem._paid = paid;
    // if(dataItem.credit_paid == null)
    //   dataItem.credit_pending = dataItem.cost - paid;
    // else
      dataItem.credit_pending = dataItem.cost - dataItem.credit_paid - paid;
    // console.log(event, dataItem, this.view.value.data);

    this.updatePagoGlobal()
    

  }

  protected onChangePagoGlobal(event) {

    // console.log(event);
    this.sumPaid = event;
    var saldo = event;
    this.data.forEach((cell, i) => {
      if(saldo > 0) {
        var nuevo_saldo = saldo - cell._credit_pending; //50
        // console.log(i, '->', saldo, '-', cell._credit_pending, '=', nuevo_saldo)
        if(nuevo_saldo > 0 ){
          cell._paid = cell._credit_pending;
          saldo -= cell._credit_pending;
        }
        else {
          cell._paid = saldo;
          saldo = 0;
        }
        cell.credit_pending = cell.cost - cell.credit_paid - cell._paid;
      }
      else {
        cell._paid = null;
      }
    });

  }

  protected updatePagoGlobal() {

    this.sumPaid = 0;
    this.data.forEach((cell, i) => {
      this.sumPaid += (cell._paid != null) ? cell._paid: 0;
    });

    // console.log(this.sumPaid);


  }

  protected onSave() {

    this.window.label = 'Pago';
    // this.window.table = this.table;
    this.window.process(this.sumPaid);    

  }

  protected windowSaveHandler(event: any) {

    var credits = this.data.filter((cell, i) => {
      return cell._paid != null;
    }).map((cell, i) => {
      return {"type": cell.type, "id": cell.id, "cost": cell._paid};
    });

    this.service.addRow('pay', {
      "date": event.dataItem.date,
      "id_customer": this.customerData.id,
      "total": this.sumPaid,
      "id_payment_type": event.dataItem.id_payment_type,
      "id_person": event.dataItem.id_person,
      "credits": credits
    })
      .subscribe(
        (result: any) => {
          // console.log(result);
          this.alertService.showAddSuccess(`${credits.length} pago(s) de créditos`);
          // this.customerData = result.data[0];
          // this.refreshHandler();

          this.updateCustomer(this.customer);
          // 
        },
        (error: any) => {
            console.log(error)
          // this.loading = false;
        });

  }


}